export function Divider(): JSX.Element {
  return <div className='divider' />
}
